export default __webpack_public_path__ + "static/media/TRI.01203262.svg";